import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetAboutAdrienCachotParams } from "../interface";
import LandingAboutAdrienCachot from "design-system/src/Components/WidgetPart/LandingAbout/LandingAboutAdrienCachot/LandingAboutAdrienCachot";

const AboutAdrienCachot: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetAboutAdrienCachotParams>((props) => {
    const { p } = props;

    return (
      <LandingAboutAdrienCachot
        title={p("title") + ""}
        description={p("description")}
      />
    );
  });

export default AboutAdrienCachot;
